export default {
  date: {
    days: {
      sunday: 'domenica',
      monday: 'lunedì',
      tuesday: 'martedì',
      wednesday: 'mercoledì',
      thursday: 'giovedì',
      friday: 'venerdì',
      saturday: 'sabato'
    },
    daysShort: {
      sun: 'do',
      mon: 'lun',
      tue: 'mar',
      wed: 'mer',
      thu: 'gio',
      fri: 'ven',
      sat: 'sab'
    },
    months: {
      januray: 'gennaio',
      february: 'febbraio',
      march: 'marzo',
      april: 'aprile',
      may: 'maggio',
      june: 'giugno',
      july: 'luglio',
      august: 'agosto',
      september: 'settembre',
      october: 'ottobre',
      november: 'novembre',
      december: 'dicembre'
    },
    monthsShort: {
      jan: 'gen',
      feb: 'feb',
      mar: 'mar',
      apr: 'apr',
      may: 'mag',
      jun: 'giu',
      jul: 'lug',
      aug: 'ag',
      sep: 'set',
      oct: 'ott',
      nov: 'nov',
      dec: 'dic'
    }
  }
};